import { render, staticRenderFns } from "./ModalLampEdit.vue?vue&type=template&id=2a3f7347&scoped=true"
import script from "./ModalLampEdit.vue?vue&type=script&lang=js"
export * from "./ModalLampEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalLampEdit.vue?vue&type=style&index=0&id=2a3f7347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3f7347",
  null
  
)

export default component.exports